/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_TiktokInputs */

const cs_enum_tiktok = /** @type {(inputs: Enum_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

const en_enum_tiktok = /** @type {(inputs: Enum_TiktokInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`TikTok`)
};

/**
* | output |
* | --- |
* | "TikTok" |
*
* @param {Enum_TiktokInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_tiktok = /** @type {((inputs?: Enum_TiktokInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_TiktokInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_tiktok(inputs)
	return cs_enum_tiktok(inputs)
});